module.exports = __webpack_public_path__ + "001495fa3ff83302e7e71cdb0ecce1bf.fbx";